

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.BC6_Zb_X.js","_app/immutable/chunks/disclose-version.BL6hcnec.js","_app/immutable/chunks/index-client.rXPpudJw.js","_app/immutable/chunks/legacy.C_sX5KDq.js","_app/immutable/chunks/render.DKgo8NLL.js","_app/immutable/chunks/events.0Dsuk1hn.js","_app/immutable/chunks/lifecycle.DVeK0_Ql.js","_app/immutable/chunks/entry.CW1Rx1dT.js"];
export const stylesheets = [];
export const fonts = [];
